import { CloudPrice, CloudPriceEntries, CloudPriceType } from '@/shared/types/prices';
import { CurrencyCode } from '@/shared/constants/currencies';

export const cloudPriceEntriesToCloudPrices = (
  prices: CloudPriceEntries | null | undefined,
  currencyCode: string,
): CloudPrice[] => {
  if (!prices) {
    return [];
  }
  return Object.entries(prices)
    .filter(([, currencyValues]) => currencyCode in currencyValues)
    .map(
      ([type, currencyValues]) =>
        ({
          type: type as CloudPriceType,
          currencyCode: currencyCode as CurrencyCode,
          value: currencyValues[currencyCode as keyof typeof currencyValues],
        }) as CloudPrice,
    );
};
